__turbopack_context__.v({
  "avatar": "UserMenuDropdown-module__7yi7IG__avatar",
  "chevron": "UserMenuDropdown-module__7yi7IG__chevron",
  "dropdown": "UserMenuDropdown-module__7yi7IG__dropdown",
  "menuItem": "UserMenuDropdown-module__7yi7IG__menuItem",
  "name": "UserMenuDropdown-module__7yi7IG__name",
  "toggle": "UserMenuDropdown-module__7yi7IG__toggle",
  "userInfo": "UserMenuDropdown-module__7yi7IG__userInfo",
  "wrapper": "UserMenuDropdown-module__7yi7IG__wrapper",
});
